<template>
  <AddFamilyTemplate :header="header">
    <template #content>
      <v-layout
        justify-center
        class="pt-4"
      >
        <v-flex
          xs10
          sm8
        >
          <p class="required-block required-block_left mb-2">
            {{ $t('label.required_fields') }}
          </p>
          <h2 class="display-3 display-3_dark mb-1">
            {{ $t('message.about_family') }}
          </h2>
          <p
            class="required-block"
            :class="[mobileScreen ? 'mb-0' : 'f-1']"
          >
            {{ $t('message.choose_help_criteria') }}
          </p>
          <SelectableList
            v-model="helpCriteria"
            v-validate="'required'"
            :items="getHelpCriteria"
            :exclusion-elem="exclusionElem"
            :error-messages="errors.collect('helpCriteria')"
            :data-vv-as="' '"
            :data-vv-name="'helpCriteria'"
            data-vv-validate-on="input"
          />
          <p
            class="mt-4"
            :class="[mobileScreen ? 'mb-1' : 'f-1']"
          >
            {{ $t('message.add_note_for_volunteer') }}
          </p>
          <v-textarea
            ref="note"
            v-model="note"
            v-validate="validationRules.get('long_regular_field')"
            name="input-7-1"
            auto-grow
            :placeholder="$t('label.message')"
            :error-messages="errors.collect('regular_field')"
            data-vv-name="regular_field"
          />
          <v-layout
            v-if="isFormValid === false"
            mb-0
            mt-4
          >
            <v-flex>
              <div class="v-message text-xs-center">
                <div class="v-messages__message">
                  {{ $t('errors.form_not_valid') }}
                </div>
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </template>
    <template #actions>
      <v-layout
        align-center
        justify-end
        wrap
        :justify-center="$vuetify.breakpoint.xs"
      >
        <v-flex
          shrink
          :mr-4="$vuetify.breakpoint.smAndUp"
          order-xs2
          order-sm1
          :mt-2="$vuetify.breakpoint.xs"
        >
          <a
            class="link_iconed"
            @click="prevStep()"
          >
            <v-icon>chevron_left</v-icon>{{ $t('buttons.prev_button') }}
          </a>
        </v-flex>
        <v-flex
          shrink
          order-xs1
          order-sm2
        >
          <v-btn
            color="sz_violet"
            :loading="getSendLoader"
            :disabled="getSendLoader"
            @click="submitValidate()"
          >
            {{ $t('buttons.send') }}
          </v-btn>
        </v-flex>
      </v-layout>
    </template>
  </AddFamilyTemplate>
</template>

<script>
import AddFamilyTemplate from '@/components/addFamily/AddFamilyTemplate';
import SelectableList from '@/components/widgets/SelectableList';

import validationRules from '@/constants/validationRules';

import scrollToTopErrorMessage from '@/mixins/scrollToTopErrorMessage';

import { mapFields } from 'vuex-map-fields';
import { mapGetters } from 'vuex';

export default {
    name: 'FamilyInformation',
    components: { AddFamilyTemplate, SelectableList },
    mixins: [scrollToTopErrorMessage],
    inject: ['$validator'],
    data () {
        return {
            validationRules,
            exclusionElem: 8,
            isFormValid: true
        };
    },
    computed: {
        ...mapFields('familyData', ['aboutFamilyData.helpCriteria', 'aboutFamilyData.note']),
        ...mapGetters('defaultApi', ['getHelpCriteria']),
        ...mapGetters('familyData', ['getSendLoader']),
        header () {
            return {
                title: this.$t('add_family.page_title'),
                subtitle: this.$t('add_family.page_subtitle')
            };
        },
        mobileScreen () {
            return this.$vuetify.breakpoint.xs;
        }
    },
    methods: {
        prevStep () {
            this.$router.push({ name: 'family-source' });
        },
        submitValidate () {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.isFormValid = true;
                    this.postFamilyInternal();
                } else {
                    this.isFormValid = false;
                    this.scrollToTopErrorMessage();
                }
            });
        },
        postFamilyInternal () {
            this.$store.dispatch('familyData/postFamilyInternal').then(({ data }) => {
                const isGlued = data && data.data && data.data.is_glued;
                this.$gtm.trackEvent({
                    event: 'internal-form-submit',
                    action: 'form-submit',
                    label: 'add family (internal form)'
                });
                this.$router.push({ name: 'family-summary', params: { isGlued: !!isGlued } });
            });
        }
    },
    beforeRouteEnter (to, from, next) {
        next((vm) => {
            vm.$store.dispatch('defaultApi/getHelpCriteria');
        });
    }
};
</script>

<style scoped></style>
